import {
    SECRETARY_PATCH_FAILURE,
    SECRETARY_PATCH_REQUEST,
    SECRETARY_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, secretary} = action;
    switch (type) {
        case SECRETARY_PATCH_SUCCESS: {return {
            ...initialState,
            secretary,
        }}

        case SECRETARY_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case SECRETARY_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
